import React from 'react'

const UnmuteIcon = () => {
  return (
    <div className='flex items-center justify-center w-10 h-10 bg-black/[.60] rounded-full'>
      <svg
        role='button'
        aria-label='Unmute'
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        fill='none'
        viewBox='0 0 20 20'
      >
        <title>Unmute</title>
        <g clipPath='url(#clip0_2387_72427)'>
          <path
            fill='#fff'
            d='M10.139 2.121a.445.445 0 01.75.323v15.111a.444.444 0 01-.75.323l-4.577-4.322H2.444A.444.444 0 012 13.11V6.89c0-.246.199-.445.444-.445h3.118l4.577-4.323zm5.32 2.865a.444.444 0 01.642.01A7.525 7.525 0 0118 10c0 1.917-.718 3.67-1.899 5.004a.444.444 0 01-.643.01l-.629-.63a.448.448 0 01-.011-.613A5.753 5.753 0 0016.222 10c0-1.44-.53-2.759-1.404-3.772a.448.448 0 01.011-.613l.63-.629zM12.934 7.51a.452.452 0 01.679.053c.52.675.83 1.521.83 2.438a3.98 3.98 0 01-.83 2.438.452.452 0 01-.679.053l-.633-.633c-.146-.146-.185-.382-.063-.549A2.21 2.21 0 0012.667 10a2.21 2.21 0 00-.428-1.31c-.122-.166-.083-.402.063-.548l.633-.633z'
          ></path>
        </g>
        <defs>
          <clipPath id='clip0_2387_72427'>
            <path fill='#fff' d='M0 0H20V20H0z'></path>
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default UnmuteIcon
